function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 24.5,
  r: 18.5,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 2C11.8697 2 2 11.8697 2 24C2 36.1303 11.8697 46 24 46C36.1303 46 46 36.1303 46 24C46 11.8697 36.1303 2 24 2ZM36.2957 18.2105L22.2356 32.1604C21.4085 32.9875 20.0852 33.0426 19.203 32.2155L11.7594 25.4336C10.8772 24.6065 10.8221 23.2281 11.594 22.3459C12.4211 21.4637 13.7995 21.4085 14.6817 22.2356L20.5815 27.6391L33.1529 15.0677C34.0351 14.1855 35.4135 14.1855 36.2957 15.0677C37.1779 15.9499 37.1779 17.3283 36.2957 18.2105Z",
  fill: "url(#paint0_linear_155_4341)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_155_4341",
  x1: 46,
  y1: 2,
  x2: 2,
  y2: 46,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#18C889"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00AAAA"
})));

function SvgAlertSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSuccess);
export default __webpack_public_path__ + "static/media/alert-success.3985f077.svg";
export { ForwardRef as ReactComponent };